import { Chip } from '@/global/components/Chip'
import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import { Scope } from '@acme/core'
import { SCOPE_DESCRIPTIONS } from './CredencialForm'

/** Colunas que as telas do cliente e da administração exibem igual. */
export const colunaEscopos: GridColDefPro = {
    field: 'scopes',
    headerName: 'Escopos',
    flex: 1.5,
    minWidth: 220,
    valueGetter: ({ value }) =>
        Array.isArray(value)
            ? value
                  .map(
                      (scope: Scope) =>
                          SCOPE_DESCRIPTIONS[scope]?.label ?? scope,
                  )
                  .join(', ')
            : '',
}

export const colunaStatus: GridColDefPro = {
    field: 'ativo',
    headerName: 'Status',
    width: 110,
    align: 'center',
    renderCell: ({ value }) =>
        value === 'S' ? (
            <Chip label="Ativo" color="success" />
        ) : (
            <Chip label="Inativo" color="error" />
        ),
}
